import { render } from "./EditMedicationPharmacy.vue?vue&type=template&id=01681d73&scoped=true"
import script from "./EditMedicationPharmacy.vue?vue&type=script&lang=js"
export * from "./EditMedicationPharmacy.vue?vue&type=script&lang=js"

import "./EditMedicationPharmacy.vue?vue&type=style&index=0&id=01681d73&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01681d73"]])

export default __exports__